import { createSelector } from 'reselect';
import { EventsStore } from '../types/eventsTypes';

type Store = {
  events: EventsStore;
};

const getEventsModule = (state: Store): EventsStore => state.events;

export const getEvents = createSelector(getEventsModule, ({ events }) => events);

export const getEventsFilters = createSelector(getEventsModule, ({ filters }) => filters);

export const getEventSortDesc = createSelector(getEventsModule, ({ sortDesc }) => sortDesc);

export const getEventsDetails = createSelector(
  getEventsModule,
  ({ eventsDetails }) => eventsDetails,
);

export const getEventTitles = createSelector(getEventsModule, ({ eventTitles }) => eventTitles);

export const getEventSessions = createSelector(
  getEventsModule,
  ({ eventSessions }) => eventSessions,
);

export const getSessionsDetails = createSelector(
  getEventsModule,
  ({ sessionsDetails }) => sessionsDetails,
);

export const getEventProperties = createSelector(getEventsModule, ({ properties }) => properties);
